const GENERIC_LINK_LABELS = new Set(["view details", "learn more", "click here"]);

/**
 * Returns the first non-empty trimmed string from the candidates.
 * @param {...unknown} candidates - Candidate label values.
 * @returns {string|undefined} First usable label.
 */
function pickLabel(...candidates) {
  return candidates.find((value) => typeof value === "string" && value.trim())?.trim();
}

/**
 * Builds a unique accessible name for a linked homepage cell.
 * Rejects whitespace-only CMS values and generic placeholders.
 * @param {object} cell - Dynamic home cell data.
 * @returns {string} Accessible link label.
 */
export function getCellAccessibleLabel(cell) {
  const descriptiveLabel = pickLabel(cell?.alt, cell?.title, cell?.textContent);

  if (descriptiveLabel && !GENERIC_LINK_LABELS.has(descriptiveLabel.toLowerCase())) {
    return descriptiveLabel;
  }

  try {
    const pathname = new URL(cell?.linkUrl, "https://www.fnp.com").pathname;
    const slug = decodeURIComponent(pathname.split("/").filter(Boolean).pop() || "")
      .replace(/-lp$/i, "")
      .replace(/[-_]+/g, " ")
      .trim();

    if (slug) {
      return `View ${slug}`;
    }
  } catch {
    // Fall through to the stable default for malformed CMS URLs.
  }

  return "View gift collection";
}
